/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "buddhist",
          "chinese": "chinese",
          "coptic": "coptic",
          "dangi": "dangi",
          "ethiopic": "ethiopic",
          "ethiopic-amete-alem": "ethiopic-amete-alem",
          "gregorian": "gregorian",
          "hebrew": "hebrew",
          "indian": "indian",
          "islamic": "islamic",
          "islamic-civil": "islamic-civil",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "islamic-umalqura",
          "iso8601": "iso8601",
          "japanese": "japanese",
          "persian": "persian",
          "roc": "roc"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "ADP",
          "AED": "dirâm tî âEmirâti tî Arâbo Ôko",
          "AFA": "AFA",
          "AFN": "AFN",
          "ALK": "ALK",
          "ALL": "ALL",
          "AMD": "AMD",
          "ANG": "ANG",
          "AOA": "kwânza tî Angoläa",
          "AOK": "AOK",
          "AON": "AON",
          "AOR": "AOR",
          "ARA": "ARA",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "ARP",
          "ARS": "ARS",
          "ATS": "ATS",
          "AUD": "dolära tî Ostralïi",
          "AWG": "AWG",
          "AZM": "AZM",
          "AZN": "AZN",
          "BAD": "BAD",
          "BAM": "BAM",
          "BAN": "BAN",
          "BBD": "BBD",
          "BDT": "BDT",
          "BEC": "BEC",
          "BEF": "BEF",
          "BEL": "BEL",
          "BGL": "BGL",
          "BGM": "BGM",
          "BGN": "BGN",
          "BGO": "BGO",
          "BHD": "dolùara tî Bahrâina",
          "BIF": "farânga tî Burundïi",
          "BMD": "BMD",
          "BND": "BND",
          "BOB": "BOB",
          "BOL": "BOL",
          "BOP": "BOP",
          "BOV": "BOV",
          "BRB": "BRB",
          "BRC": "BRC",
          "BRE": "BRE",
          "BRL": "BRL",
          "BRN": "BRN",
          "BRR": "BRR",
          "BRZ": "BRZ",
          "BSD": "BSD",
          "BTN": "BTN",
          "BUK": "BUK",
          "BWP": "pûla tî Botswana",
          "BYB": "BYB",
          "BYN": "BYN",
          "BYR": "BYR",
          "BZD": "BZD",
          "CAD": "dolära tî kanadäa",
          "CDF": "farânga tî Kongöo",
          "CHE": "CHE",
          "CHF": "farânga tî Sûîsi",
          "CHW": "CHW",
          "CLE": "CLE",
          "CLF": "CLF",
          "CLP": "CLP",
          "CNH": "CNH",
          "CNX": "CNX",
          "CNY": "yuan renminbi tî Shîni",
          "COP": "COP",
          "COU": "COU",
          "CRC": "CRC",
          "CSD": "CSD",
          "CSK": "CSK",
          "CUC": "CUC",
          "CUP": "CUP",
          "CVE": "eskûêdo tî Kâpo-Vêre",
          "CYP": "CYP",
          "CZK": "CZK",
          "DDM": "DDM",
          "DEM": "DEM",
          "DJF": "farânga tî Dibutïi",
          "DKK": "DKK",
          "DOP": "DOP",
          "DZD": "dinäri tî Alzerïi",
          "ECS": "ECS",
          "ECV": "ECV",
          "EEK": "EEK",
          "EGP": "pôndo tî Kâmitâ",
          "ERN": "nakafa tî Eritrëe",
          "ESA": "ESA",
          "ESB": "ESB",
          "ESP": "ESP",
          "ETB": "bir tî Etiopïi",
          "EUR": "zoröo",
          "FIM": "FIM",
          "FJD": "FJD",
          "FKP": "FKP",
          "FRF": "FRF",
          "GBP": "pôndo tî Anglëe",
          "GEK": "GEK",
          "GEL": "GEL",
          "GHC": "sêdi tî Ganäa",
          "GHS": "GHS",
          "GIP": "GIP",
          "GMD": "dalasi tî gambïi",
          "GNF": "GNF",
          "GNS": "sili tî Ginëe",
          "GQE": "GQE",
          "GRD": "GRD",
          "GTQ": "GTQ",
          "GWE": "GWE",
          "GWP": "GWP",
          "GYD": "GYD",
          "HKD": "HKD",
          "HNL": "HNL",
          "HRD": "HRD",
          "HRK": "HRK",
          "HTG": "HTG",
          "HUF": "HUF",
          "IDR": "IDR",
          "IEP": "IEP",
          "ILP": "ILP",
          "ILR": "ILR",
          "ILS": "ILS",
          "INR": "rupïi tî Ênnde",
          "IQD": "IQD",
          "IRR": "IRR",
          "ISJ": "ISJ",
          "ISK": "ISK",
          "ITL": "ITL",
          "JMD": "JMD",
          "JOD": "JOD",
          "JPY": "yêni tî Zapön",
          "KES": "shilîngi tî Kenyäa",
          "KGS": "KGS",
          "KHR": "KHR",
          "KMF": "farânga tî Kömôro",
          "KPW": "KPW",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "KRW",
          "KWD": "KWD",
          "KYD": "KYD",
          "KZT": "KZT",
          "LAK": "LAK",
          "LBP": "LBP",
          "LKR": "LKR",
          "LRD": "dolära tî Liberïa",
          "LSL": "loti tî Lesôtho",
          "LTL": "LTL",
          "LTT": "LTT",
          "LUC": "LUC",
          "LUF": "LUF",
          "LUL": "LUL",
          "LVL": "LVL",
          "LVR": "LVR",
          "LYD": "dinäar tî Libïi",
          "MAD": "dirâm tî Marôko",
          "MAF": "MAF",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "MDL",
          "MGA": "ariâri tî Madagasikära",
          "MGF": "MGF",
          "MKD": "MKD",
          "MKN": "MKN",
          "MLF": "MLF",
          "MMK": "MMK",
          "MNT": "MNT",
          "MOP": "MOP",
          "MRO": "ugîya tî Moritanïi (1973–2017)",
          "MRU": "ugîya tî Moritanïi",
          "MTL": "MTL",
          "MTP": "MTP",
          "MUR": "rupïi tî Mörîsi",
          "MVP": "MVP",
          "MVR": "MVR",
          "MWK": "kwâtia tî Malawïi",
          "MXN": "MXN",
          "MXP": "MXP",
          "MXV": "MXV",
          "MYR": "MYR",
          "MZE": "MZE",
          "MZM": "metikala tî Mozambîka",
          "MZN": "MZN",
          "NAD": "dolära tî Namibïi",
          "NGN": "nâîra tî Nizerïa",
          "NIC": "NIC",
          "NIO": "NIO",
          "NLG": "NLG",
          "NOK": "NOK",
          "NPR": "NPR",
          "NZD": "NZD",
          "OMR": "OMR",
          "PAB": "PAB",
          "PEI": "PEI",
          "PEN": "PEN",
          "PES": "PES",
          "PGK": "PGK",
          "PHP": "PHP",
          "PKR": "PKR",
          "PLN": "PLN",
          "PLZ": "PLZ",
          "PTE": "PTE",
          "PYG": "PYG",
          "QAR": "QAR",
          "RHD": "RHD",
          "ROL": "ROL",
          "RON": "RON",
          "RSD": "RSD",
          "RUB": "RUB",
          "RUR": "RUR",
          "RWF": "farânga tî Ruandäa",
          "SAR": "riâli tî Saûdi Arabïi",
          "SBD": "SBD",
          "SCR": "rupïi tî Sëyshêle",
          "SDD": "SDD",
          "SDG": "pôndo tî Sudäan",
          "SDP": "SDP",
          "SEK": "SEK",
          "SGD": "SGD",
          "SHP": "pôndo tî Zûâ Sênt-Helêna",
          "SIT": "SIT",
          "SKK": "SKK",
          "SLL": "leône tî Sierâ-Leône",
          "SOS": "shilîngi tî Somalïi",
          "SRD": "SRD",
          "SRG": "SRG",
          "SSP": "SSP",
          "STD": "dôbra tî Sâô Tomë na Prinsîpe (1977–2017)",
          "STN": "dôbra tî Sâô Tomë na Prinsîpe",
          "SUR": "SUR",
          "SVC": "SVC",
          "SYP": "SYP",
          "SZL": "lilangùeni tî Swazïlânde",
          "THB": "THB",
          "TJR": "TJR",
          "TJS": "TJS",
          "TMM": "TMM",
          "TMT": "TMT",
          "TND": "dinära tî Tunizïi",
          "TOP": "TOP",
          "TPE": "TPE",
          "TRL": "TRL",
          "TRY": "TRY",
          "TTD": "TTD",
          "TWD": "TWD",
          "TZS": "shilîngi tî Tanzanïi",
          "UAH": "UAH",
          "UAK": "UAK",
          "UGS": "UGS",
          "UGX": "shilîngi tî Ugandäa",
          "USD": "dol$ara ttî äLetäa-Ôko tî Amerîka",
          "USN": "USN",
          "USS": "USS",
          "UYI": "UYI",
          "UYP": "UYP",
          "UYU": "UYU",
          "UYW": "UYW",
          "UZS": "UZS",
          "VEB": "VEB",
          "VEF": "VEF",
          "VES": "VES",
          "VND": "VND",
          "VNN": "VNN",
          "VUV": "VUV",
          "WST": "WST",
          "XAF": "farânga CFA (BEAC)",
          "XAG": "XAG",
          "XAU": "XAU",
          "XBA": "XBA",
          "XBB": "XBB",
          "XBC": "XBC",
          "XBD": "XBD",
          "XCD": "XCD",
          "XDR": "XDR",
          "XEU": "XEU",
          "XFO": "XFO",
          "XFU": "XFU",
          "XOF": "farânga CFA (BCEAO)",
          "XPD": "XPD",
          "XPF": "XPF",
          "XPT": "XPT",
          "XRE": "XRE",
          "XSU": "XSU",
          "XTS": "XTS",
          "XUA": "XUA",
          "XXX": "XXX",
          "YDD": "YDD",
          "YER": "YER",
          "YUD": "YUD",
          "YUM": "YUM",
          "YUN": "YUN",
          "YUR": "YUR",
          "ZAL": "ZAL",
          "ZAR": "rânde tî Mbongo-Afrîka",
          "ZMK": "kwâtia tî Zambïi (1968–2012)",
          "ZMW": "kwâtia tî Zambïi",
          "ZRN": "ZRN",
          "ZRZ": "ZRZ",
          "ZWD": "dolära tî Zimbäbwe",
          "ZWL": "ZWL",
          "ZWR": "ZWR"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "Lâ",
          "dayOfYear": "Day Of Year",
          "dayperiod": "Na lâ",
          "era": "Kùotângo",
          "hour": "Ngbonga",
          "minute": "Ndurü ngbonga",
          "month": "Nze",
          "quarter": "Quarter",
          "second": "Nzîna ngbonga",
          "timeZoneName": "Zukangbonga",
          "weekOfMonth": "Week Of Month",
          "weekOfYear": "Dimâsi",
          "weekday": "Bïkua",
          "weekdayOfMonth": "Weekday Of Month",
          "year": "Ngû"
        },
        "narrow": {
          "day": "Lâ",
          "dayOfYear": "Day Of Year",
          "dayperiod": "Na lâ",
          "era": "Kùotângo",
          "hour": "Ngbonga",
          "minute": "Ndurü ngbonga",
          "month": "Nze",
          "quarter": "Quarter",
          "second": "Nzîna ngbonga",
          "timeZoneName": "Zukangbonga",
          "weekOfMonth": "Week Of Month",
          "weekOfYear": "Dimâsi",
          "weekday": "Bïkua",
          "weekdayOfMonth": "Weekday Of Month",
          "year": "Ngû"
        },
        "short": {
          "day": "Lâ",
          "dayOfYear": "Day Of Year",
          "dayperiod": "Na lâ",
          "era": "Kùotângo",
          "hour": "Ngbonga",
          "minute": "Ndurü ngbonga",
          "month": "Nze",
          "quarter": "Quarter",
          "second": "Nzîna ngbonga",
          "timeZoneName": "Zukangbonga",
          "weekOfMonth": "Week Of Month",
          "weekOfYear": "Dimâsi",
          "weekday": "Bïkua",
          "weekdayOfMonth": "Weekday Of Month",
          "year": "Ngû"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "ab": "ab",
            "af": "af",
            "agq": "agq",
            "ak": "Akâan",
            "am": "Amarîki",
            "ar": "Arâbo",
            "ar-001": "Arâbo (001)",
            "as": "as",
            "asa": "asa",
            "ast": "ast",
            "az": "az",
            "bas": "bas",
            "be": "Bielörûsi",
            "bem": "bem",
            "bez": "bez",
            "bg": "Bulugäri",
            "bm": "bm",
            "bn": "Bengäli",
            "bo": "bo",
            "br": "br",
            "brx": "brx",
            "bs": "bs",
            "ca": "ca",
            "ccp": "ccp",
            "ce": "ce",
            "ceb": "ceb",
            "cgg": "cgg",
            "chr": "chr",
            "ckb": "ckb",
            "co": "co",
            "cs": "Tyêki",
            "cu": "cu",
            "cy": "cy",
            "da": "da",
            "dav": "dav",
            "de": "Zâmani",
            "de-AT": "Zâmani (Otrîsi)",
            "de-CH": "Zâmani (Sûîsi)",
            "dje": "dje",
            "doi": "doi",
            "dsb": "dsb",
            "dua": "dua",
            "dyo": "dyo",
            "dz": "dz",
            "ebu": "ebu",
            "ee": "ee",
            "el": "Gerêki",
            "en": "Anglëe",
            "en-AU": "Anglëe (Ostralïi, Sotralïi)",
            "en-CA": "Anglëe (Kanadäa)",
            "en-GB": "Anglëe (Ködörögbïä--Ôko)",
            "en-US": "Anglëe (ÂLeaa-Ôko tî Amerika)",
            "eo": "eo",
            "es": "Espanyöl",
            "es-419": "Espanyöl (419)",
            "es-ES": "Espanyöl (Espânye)",
            "es-MX": "Espanyöl (Mekisîki)",
            "et": "et",
            "eu": "eu",
            "ewo": "ewo",
            "fa": "Farsî",
            "fa-AF": "Farsî (Faganïta, Afganïstäan)",
            "ff": "ff",
            "fi": "fi",
            "fil": "fil",
            "fo": "fo",
            "fr": "Farânzi",
            "fr-CA": "Farânzi (Kanadäa)",
            "fr-CH": "Farânzi (Sûîsi)",
            "frc": "frc",
            "fur": "fur",
            "fy": "fy",
            "ga": "ga",
            "gd": "gd",
            "gl": "gl",
            "gsw": "gsw",
            "gu": "gu",
            "guz": "guz",
            "gv": "gv",
            "ha": "Haüsä",
            "haw": "haw",
            "he": "he",
            "hi": "Hîndi",
            "hmn": "hmn",
            "hr": "hr",
            "hsb": "hsb",
            "ht": "ht",
            "hu": "Hongruäa",
            "hy": "hy",
            "ia": "ia",
            "id": "Enndonezïi",
            "ig": "Ïgbö",
            "ii": "ii",
            "is": "is",
            "it": "Ênnde",
            "ja": "Zaponëe",
            "jgo": "jgo",
            "jmc": "jmc",
            "jv": "Zavanëe",
            "ka": "ka",
            "kab": "kab",
            "kam": "kam",
            "kde": "kde",
            "kea": "kea",
            "kgp": "kgp",
            "khq": "khq",
            "ki": "ki",
            "kk": "kk",
            "kkj": "kkj",
            "kl": "kl",
            "kln": "kln",
            "km": "Kmêre",
            "kn": "kn",
            "ko": "Koreyëen",
            "kok": "kok",
            "ks": "ks",
            "ksb": "ksb",
            "ksf": "ksf",
            "ksh": "ksh",
            "ku": "ku",
            "kw": "kw",
            "ky": "ky",
            "la": "la",
            "lag": "lag",
            "lb": "lb",
            "lg": "lg",
            "lij": "lij",
            "lkt": "lkt",
            "ln": "ln",
            "lo": "lo",
            "lou": "lou",
            "lrc": "lrc",
            "lt": "lt",
            "lu": "lu",
            "luo": "luo",
            "luy": "luy",
            "lv": "lv",
            "mai": "mai",
            "mas": "mas",
            "mer": "mer",
            "mfe": "mfe",
            "mg": "mg",
            "mgh": "mgh",
            "mgo": "mgo",
            "mi": "mi",
            "mk": "mk",
            "ml": "ml",
            "mn": "mn",
            "mni": "mni",
            "mr": "mr",
            "ms": "Malëe",
            "mt": "mt",
            "mua": "mua",
            "mul": "mul",
            "my": "Miamära, Birimäni",
            "mzn": "mzn",
            "naq": "naq",
            "nb": "nb",
            "nd": "nd",
            "nds": "nds",
            "nds-NL": "nds (Holände)",
            "ne": "Nepalëe",
            "nl": "Holandëe",
            "nl-BE": "Holandëe (Bêleze, Belezîki)",
            "nmg": "nmg",
            "nn": "nn",
            "nnh": "nnh",
            "no": "no",
            "nus": "nus",
            "nv": "nv",
            "ny": "ny",
            "nyn": "nyn",
            "om": "om",
            "or": "or",
            "os": "os",
            "pa": "Penzäbï",
            "pcm": "pcm",
            "pl": "Polonëe",
            "prg": "prg",
            "ps": "ps",
            "pt": "Portugëe, Pûra",
            "pt-BR": "Portugëe, Pûra (Brezîli)",
            "pt-PT": "Portugëe, Pûra (Pörtugäle, Ködörö Pûra)",
            "qu": "qu",
            "rhg": "rhg",
            "rm": "rm",
            "rn": "rn",
            "ro": "Rumëen",
            "ro-MD": "Rumëen (Moldavùii)",
            "rof": "rof",
            "ru": "Rûsi",
            "rw": "Ruandäa",
            "rwk": "rwk",
            "sa": "sa",
            "sah": "sah",
            "saq": "saq",
            "sat": "sat",
            "sbp": "sbp",
            "sc": "sc",
            "sd": "sd",
            "se": "se",
            "seh": "seh",
            "ses": "ses",
            "sg": "Sängö",
            "shi": "shi",
            "si": "si",
            "sk": "sk",
            "sl": "sl",
            "sm": "sm",
            "smn": "smn",
            "sn": "sn",
            "so": "Somalïi",
            "sq": "sq",
            "sr": "sr",
            "st": "st",
            "su": "su",
            "sv": "Sueduäa",
            "sw": "sw",
            "sw-CD": "sw (Ködörösêse tî Ngunuhalëzo tî kongö)",
            "ta": "Tämûli",
            "te": "te",
            "teo": "teo",
            "tg": "tg",
            "th": "Thâi",
            "ti": "ti",
            "tk": "tk",
            "to": "to",
            "tr": "Tûrûku",
            "tt": "tt",
            "twq": "twq",
            "tzm": "tzm",
            "ug": "ug",
            "uk": "Ukrêni",
            "und": "und",
            "ur": "Ûrdu",
            "uz": "uz",
            "vai": "vai",
            "vi": "Vietnäm",
            "vo": "vo",
            "vun": "vun",
            "wae": "wae",
            "wo": "wo",
            "xh": "xh",
            "xog": "xog",
            "yav": "yav",
            "yi": "yi",
            "yo": "Yoruba",
            "yrl": "yrl",
            "yue": "yue",
            "zgh": "zgh",
            "zh": "Shinuäa",
            "zh-Hans": "Shinuäa (Hans)",
            "zh-Hant": "Shinuäa (Hant)",
            "zu": "Zûlu",
            "zxx": "zxx"
          },
          "narrow": {
          },
          "short": {
            "az": "az",
            "en-GB": "Anglëe (Ködörögbïä--Ôko)",
            "en-US": "Anglëe (ÂLeaa-Ôko tî Amerika)"
          }
        },
        "standard": {
          "long": {
            "ab": "ab",
            "af": "af",
            "agq": "agq",
            "ak": "Akâan",
            "am": "Amarîki",
            "ar": "Arâbo",
            "ar-001": "Arâbo (001)",
            "as": "as",
            "asa": "asa",
            "ast": "ast",
            "az": "az",
            "bas": "bas",
            "be": "Bielörûsi",
            "bem": "bem",
            "bez": "bez",
            "bg": "Bulugäri",
            "bm": "bm",
            "bn": "Bengäli",
            "bo": "bo",
            "br": "br",
            "brx": "brx",
            "bs": "bs",
            "ca": "ca",
            "ccp": "ccp",
            "ce": "ce",
            "ceb": "ceb",
            "cgg": "cgg",
            "chr": "chr",
            "ckb": "ckb",
            "co": "co",
            "cs": "Tyêki",
            "cu": "cu",
            "cy": "cy",
            "da": "da",
            "dav": "dav",
            "de": "Zâmani",
            "de-AT": "Zâmani (Otrîsi)",
            "de-CH": "Zâmani (Sûîsi)",
            "dje": "dje",
            "doi": "doi",
            "dsb": "dsb",
            "dua": "dua",
            "dyo": "dyo",
            "dz": "dz",
            "ebu": "ebu",
            "ee": "ee",
            "el": "Gerêki",
            "en": "Anglëe",
            "en-AU": "Anglëe (Ostralïi, Sotralïi)",
            "en-CA": "Anglëe (Kanadäa)",
            "en-GB": "Anglëe (Ködörögbïä--Ôko)",
            "en-US": "Anglëe (ÂLeaa-Ôko tî Amerika)",
            "eo": "eo",
            "es": "Espanyöl",
            "es-419": "Espanyöl (419)",
            "es-ES": "Espanyöl (Espânye)",
            "es-MX": "Espanyöl (Mekisîki)",
            "et": "et",
            "eu": "eu",
            "ewo": "ewo",
            "fa": "Farsî",
            "fa-AF": "Farsî (Faganïta, Afganïstäan)",
            "ff": "ff",
            "fi": "fi",
            "fil": "fil",
            "fo": "fo",
            "fr": "Farânzi",
            "fr-CA": "Farânzi (Kanadäa)",
            "fr-CH": "Farânzi (Sûîsi)",
            "frc": "frc",
            "fur": "fur",
            "fy": "fy",
            "ga": "ga",
            "gd": "gd",
            "gl": "gl",
            "gsw": "gsw",
            "gu": "gu",
            "guz": "guz",
            "gv": "gv",
            "ha": "Haüsä",
            "haw": "haw",
            "he": "he",
            "hi": "Hîndi",
            "hmn": "hmn",
            "hr": "hr",
            "hsb": "hsb",
            "ht": "ht",
            "hu": "Hongruäa",
            "hy": "hy",
            "ia": "ia",
            "id": "Enndonezïi",
            "ig": "Ïgbö",
            "ii": "ii",
            "is": "is",
            "it": "Ênnde",
            "ja": "Zaponëe",
            "jgo": "jgo",
            "jmc": "jmc",
            "jv": "Zavanëe",
            "ka": "ka",
            "kab": "kab",
            "kam": "kam",
            "kde": "kde",
            "kea": "kea",
            "kgp": "kgp",
            "khq": "khq",
            "ki": "ki",
            "kk": "kk",
            "kkj": "kkj",
            "kl": "kl",
            "kln": "kln",
            "km": "Kmêre",
            "kn": "kn",
            "ko": "Koreyëen",
            "kok": "kok",
            "ks": "ks",
            "ksb": "ksb",
            "ksf": "ksf",
            "ksh": "ksh",
            "ku": "ku",
            "kw": "kw",
            "ky": "ky",
            "la": "la",
            "lag": "lag",
            "lb": "lb",
            "lg": "lg",
            "lij": "lij",
            "lkt": "lkt",
            "ln": "ln",
            "lo": "lo",
            "lou": "lou",
            "lrc": "lrc",
            "lt": "lt",
            "lu": "lu",
            "luo": "luo",
            "luy": "luy",
            "lv": "lv",
            "mai": "mai",
            "mas": "mas",
            "mer": "mer",
            "mfe": "mfe",
            "mg": "mg",
            "mgh": "mgh",
            "mgo": "mgo",
            "mi": "mi",
            "mk": "mk",
            "ml": "ml",
            "mn": "mn",
            "mni": "mni",
            "mr": "mr",
            "ms": "Malëe",
            "mt": "mt",
            "mua": "mua",
            "mul": "mul",
            "my": "Miamära, Birimäni",
            "mzn": "mzn",
            "naq": "naq",
            "nb": "nb",
            "nd": "nd",
            "nds": "nds",
            "nds-NL": "nds (Holände)",
            "ne": "Nepalëe",
            "nl": "Holandëe",
            "nl-BE": "Holandëe (Bêleze, Belezîki)",
            "nmg": "nmg",
            "nn": "nn",
            "nnh": "nnh",
            "no": "no",
            "nus": "nus",
            "nv": "nv",
            "ny": "ny",
            "nyn": "nyn",
            "om": "om",
            "or": "or",
            "os": "os",
            "pa": "Penzäbï",
            "pcm": "pcm",
            "pl": "Polonëe",
            "prg": "prg",
            "ps": "ps",
            "pt": "Portugëe, Pûra",
            "pt-BR": "Portugëe, Pûra (Brezîli)",
            "pt-PT": "Portugëe, Pûra (Pörtugäle, Ködörö Pûra)",
            "qu": "qu",
            "rhg": "rhg",
            "rm": "rm",
            "rn": "rn",
            "ro": "Rumëen",
            "ro-MD": "Rumëen (Moldavùii)",
            "rof": "rof",
            "ru": "Rûsi",
            "rw": "Ruandäa",
            "rwk": "rwk",
            "sa": "sa",
            "sah": "sah",
            "saq": "saq",
            "sat": "sat",
            "sbp": "sbp",
            "sc": "sc",
            "sd": "sd",
            "se": "se",
            "seh": "seh",
            "ses": "ses",
            "sg": "Sängö",
            "shi": "shi",
            "si": "si",
            "sk": "sk",
            "sl": "sl",
            "sm": "sm",
            "smn": "smn",
            "sn": "sn",
            "so": "Somalïi",
            "sq": "sq",
            "sr": "sr",
            "st": "st",
            "su": "su",
            "sv": "Sueduäa",
            "sw": "sw",
            "sw-CD": "sw (Ködörösêse tî Ngunuhalëzo tî kongö)",
            "ta": "Tämûli",
            "te": "te",
            "teo": "teo",
            "tg": "tg",
            "th": "Thâi",
            "ti": "ti",
            "tk": "tk",
            "to": "to",
            "tr": "Tûrûku",
            "tt": "tt",
            "twq": "twq",
            "tzm": "tzm",
            "ug": "ug",
            "uk": "Ukrêni",
            "und": "und",
            "ur": "Ûrdu",
            "uz": "uz",
            "vai": "vai",
            "vi": "Vietnäm",
            "vo": "vo",
            "vun": "vun",
            "wae": "wae",
            "wo": "wo",
            "xh": "xh",
            "xog": "xog",
            "yav": "yav",
            "yi": "yi",
            "yo": "Yoruba",
            "yrl": "yrl",
            "yue": "yue",
            "zgh": "zgh",
            "zh": "Shinuäa",
            "zh-Hans": "Shinuäa (Hans)",
            "zh-Hant": "Shinuäa (Hant)",
            "zu": "Zûlu",
            "zxx": "zxx"
          },
          "narrow": {
          },
          "short": {
            "az": "az",
            "en-GB": "Anglëe (Ködörögbïä--Ôko)",
            "en-US": "Anglëe (ÂLeaa-Ôko tî Amerika)"
          }
        }
      },
      "region": {
        "long": {
          "001": "001",
          "002": "002",
          "003": "003",
          "005": "005",
          "009": "009",
          "011": "011",
          "013": "013",
          "014": "014",
          "015": "015",
          "017": "017",
          "018": "018",
          "019": "019",
          "021": "021",
          "029": "029",
          "030": "030",
          "034": "034",
          "035": "035",
          "039": "039",
          "053": "053",
          "054": "054",
          "057": "057",
          "061": "061",
          "142": "142",
          "143": "143",
          "145": "145",
          "150": "150",
          "151": "151",
          "154": "154",
          "155": "155",
          "202": "202",
          "419": "419",
          "AC": "AC",
          "AD": "Andôro",
          "AE": "Arâbo Emirâti Ôko",
          "AF": "Faganïta, Afganïstäan",
          "AG": "Antîgua na Barbûda",
          "AI": "Angûîla",
          "AL": "Albanïi",
          "AM": "Armenïi",
          "AO": "Angoläa",
          "AQ": "AQ",
          "AR": "Arzantîna",
          "AS": "Samöa tî Amerîka",
          "AT": "Otrîsi",
          "AU": "Ostralïi, Sotralïi",
          "AW": "Arûba",
          "AX": "AX",
          "AZ": "Zerebaidyäan, Azerbaidyäan,",
          "BA": "Bosnïi na Herzegovînni",
          "BB": "Barabâda",
          "BD": "Bengladêshi",
          "BE": "Bêleze, Belezîki",
          "BF": "Burkina Faso",
          "BG": "Bulugarïi",
          "BH": "Bahrâina",
          "BI": "Burundïi",
          "BJ": "Benëen",
          "BL": "BL",
          "BM": "Beremûda",
          "BN": "Brunêi",
          "BO": "Bolivïi",
          "BQ": "BQ",
          "BR": "Brezîli",
          "BS": "Bahâmasa",
          "BT": "Butäan",
          "BV": "BV",
          "BW": "Botswana",
          "BY": "Belarüsi",
          "BZ": "Belîzi",
          "CA": "Kanadäa",
          "CC": "CC",
          "CD": "Ködörösêse tî Ngunuhalëzo tî kongö",
          "CF": "Ködörösêse tî Bêafrîka",
          "CG": "Kongö",
          "CH": "Sûîsi",
          "CI": "Kôdivüära",
          "CK": "âzûâ Kûku",
          "CL": "Shilïi",
          "CM": "Kamerûne",
          "CN": "Shîna",
          "CO": "Kolombïi",
          "CP": "CP",
          "CR": "Kôsta Rîka",
          "CU": "Kubäa",
          "CV": "Azûâ tî Kâpo-Vêre",
          "CW": "CW",
          "CX": "CX",
          "CY": "Sîpri",
          "CZ": "Ködörösêse tî Tyêki",
          "DE": "Zâmani",
          "DG": "DG",
          "DJ": "Dibutùii",
          "DK": "Danemêrke",
          "DM": "Dömïnîka",
          "DO": "Ködörösêse tî Dominîka",
          "DZ": "Alzerïi",
          "EA": "EA",
          "EC": "Ekuatëre",
          "EE": "Estonïi",
          "EG": "Kâmitâ",
          "EH": "EH",
          "ER": "Eritrëe",
          "ES": "Espânye",
          "ET": "Etiopïi",
          "EU": "EU",
          "EZ": "EZ",
          "FI": "Fëlânde",
          "FJ": "Fidyïi",
          "FK": "Âzûâ tî Mälüîni",
          "FM": "Mikronezïi",
          "FO": "FO",
          "FR": "Farânzi",
          "GA": "Gaböon",
          "GB": "Ködörögbïä--Ôko",
          "GD": "Grenâda",
          "GE": "Zorzïi",
          "GF": "Güyâni tî farânzi",
          "GG": "GG",
          "GH": "Ganäa",
          "GI": "Zibraltära, Zibaratära",
          "GL": "Gorolânde",
          "GM": "Gambïi",
          "GN": "Ginëe",
          "GP": "Guadelûpu",
          "GQ": "Ginëe tî Ekuatëre",
          "GR": "Gerêsi",
          "GS": "GS",
          "GT": "Guatêmälä",
          "GU": "Guâm",
          "GW": "Gninëe-Bisau",
          "GY": "Gayâna",
          "HK": "HK",
          "HM": "HM",
          "HN": "Honduräsi",
          "HR": "Kroasïi",
          "HT": "Haitïi",
          "HU": "Hongirùii",
          "IC": "IC",
          "ID": "Ênndonezïi",
          "IE": "Irlânde",
          "IL": "Israëli",
          "IM": "IM",
          "IN": "Ênnde",
          "IO": "Sêse tî Anglëe na Ngûyämä tî Ênnde",
          "IQ": "Irâki",
          "IR": "Iräan",
          "IS": "Islânde",
          "IT": "Italùii",
          "JE": "JE",
          "JM": "Zamaîka",
          "JO": "Zordanïi",
          "JP": "Zapöon",
          "KE": "Kenyäa",
          "KG": "Kirigizitùaan",
          "KH": "Kämbôzi",
          "KI": "Kiribati",
          "KM": "Kömôro",
          "KN": "Sên-Krïstôfo-na-Nevîsi",
          "KP": "Korëe tî Banga",
          "KR": "Korëe tî Mbongo",
          "KW": "Köwêti",
          "KY": "Âzûâ Ngundë, Kaimäni",
          "KZ": "Kazakisitäan",
          "LA": "Lùaôsi",
          "LB": "Libùaan",
          "LC": "Sênt-Lisïi",
          "LI": "Liechtenstein,",
          "LK": "Sirî-Lanka",
          "LR": "Liberïa",
          "LS": "Lesôtho",
          "LT": "Lituanïi",
          "LU": "Lugzambûru",
          "LV": "Letonùii",
          "LY": "Libïi",
          "MA": "Marôko",
          "MC": "Monaköo",
          "MD": "Moldavùii",
          "ME": "ME",
          "MF": "MF",
          "MG": "Madagaskära",
          "MH": "Âzûâ Märshâl",
          "MK": "MK",
          "ML": "Malïi",
          "MM": "Myämâra",
          "MN": "Mongolïi",
          "MO": "MO",
          "MP": "Âzûâ Märïâni tî Banga",
          "MQ": "Märtïnîki",
          "MR": "Moritanïi",
          "MS": "Monserâte",
          "MT": "Mâlta",
          "MU": "Mörîsi",
          "MV": "Maldîva",
          "MW": "Malawïi",
          "MX": "Mekisîki",
          "MY": "Malezïi",
          "MZ": "Mözämbîka",
          "NA": "Namibùii",
          "NC": "Finî Kaledonïi",
          "NE": "Nizëre",
          "NF": "Zûâ Nôrfôlko",
          "NG": "Nizerïa",
          "NI": "Nikaragua",
          "NL": "Holände",
          "NO": "Nörvêzi",
          "NP": "Nëpâli",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Finî Zelânde",
          "OM": "Omâni",
          "PA": "Panama",
          "PE": "Perüu",
          "PF": "Polinezïi tî farânzi",
          "PG": "Papû Finî Ginëe, Papuazïi",
          "PH": "Filipîni",
          "PK": "Pakistäan",
          "PL": "Pölôni",
          "PM": "Sên-Pyêre na Mikelöon",
          "PN": "Pitikêrni",
          "PR": "Porto Rîko",
          "PS": "Sêse tî Palestîni",
          "PT": "Pörtugäle, Ködörö Pûra",
          "PW": "Palau",
          "PY": "Paraguëe",
          "QA": "Katära",
          "QO": "QO",
          "RE": "Reinïon",
          "RO": "Rumanïi",
          "RS": "RS",
          "RU": "Rusïi",
          "RW": "Ruandäa",
          "SA": "Saûdi Arabïi",
          "SB": "Zûâ Salomöon",
          "SC": "Sëyshêle",
          "SD": "Sudäan",
          "SE": "Suêde",
          "SG": "Sïngäpûru",
          "SH": "Sênt-Helêna",
          "SI": "Solovenïi",
          "SJ": "SJ",
          "SK": "Solovakïi",
          "SL": "Sierä-Leône",
          "SM": "Sên-Marëen",
          "SN": "Senegäle",
          "SO": "Somalïi",
          "SR": "Surinäm",
          "SS": "SS",
          "ST": "Sâô Tömê na Prinsîpe",
          "SV": "Salvadöro",
          "SX": "SX",
          "SY": "Sirïi",
          "SZ": "Swäzïlânde",
          "TA": "TA",
          "TC": "Âzûâ Turku na Kaîki",
          "TD": "Tyâde",
          "TF": "TF",
          "TG": "Togö",
          "TH": "Tailânde",
          "TJ": "Taazikiistäan",
          "TK": "Tokelau",
          "TL": "Timôro tî Tö",
          "TM": "Turkumenistäan",
          "TN": "Tunizïi",
          "TO": "Tonga",
          "TR": "Turukïi",
          "TT": "Trinitùee na Tobagö",
          "TV": "Tüvalü",
          "TW": "Tâiwâni",
          "TZ": "Tanzanïi",
          "UA": "Ukrêni",
          "UG": "Ugandäa",
          "UM": "UM",
          "UN": "UN",
          "US": "ÂLeaa-Ôko tî Amerika",
          "UY": "Uruguëe",
          "UZ": "Uzbekistäan",
          "VA": "Letëe tî Vatikäan",
          "VC": "Sên-Vensäan na âGrenadîni",
          "VE": "Venezueläa",
          "VG": "Âzôâ Viîrîggo tî Anglëe",
          "VI": "Âzûâ Virîgo tî Amerîka",
          "VN": "Vietnäm",
          "VU": "Vanuatü",
          "WF": "Walîsi na Futuna",
          "WS": "Samoäa",
          "XA": "XA",
          "XB": "XB",
          "XK": "XK",
          "YE": "Yëmêni",
          "YT": "Mäyôte",
          "ZA": "Mbongo-Afrîka",
          "ZM": "Zambïi",
          "ZW": "Zimbäbwe",
          "ZZ": "ZZ"
        },
        "narrow": {
        },
        "short": {
          "GB": "Ködörögbïä--Ôko",
          "HK": "HK",
          "MO": "MO",
          "PS": "Sêse tî Palestîni",
          "US": "ÂLeaa-Ôko tî Amerika"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "Arab",
          "Aran": "Aran",
          "Armi": "Armi",
          "Armn": "Armn",
          "Avst": "Avst",
          "Bali": "Bali",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "Batk",
          "Beng": "Beng",
          "Bhks": "Bhks",
          "Bopo": "Bopo",
          "Brah": "Brah",
          "Brai": "Brai",
          "Bugi": "Bugi",
          "Buhd": "Buhd",
          "Cakm": "Cakm",
          "Cans": "Cans",
          "Cari": "Cari",
          "Cham": "Cham",
          "Cher": "Cher",
          "Chrs": "Chrs",
          "Copt": "Copt",
          "Cpmn": "Cpmn",
          "Cprt": "Cprt",
          "Cyrl": "Cyrl",
          "Deva": "Deva",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "Dsrt",
          "Dupl": "Dupl",
          "Egyp": "Egyp",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "Ethi",
          "Geor": "Geor",
          "Glag": "Glag",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "Goth",
          "Gran": "Gran",
          "Grek": "Grek",
          "Gujr": "Gujr",
          "Guru": "Guru",
          "Hanb": "Hanb",
          "Hang": "Hang",
          "Hani": "Hani",
          "Hano": "Hano",
          "Hans": "Hans",
          "Hant": "Hant",
          "Hatr": "Hatr",
          "Hebr": "Hebr",
          "Hira": "Hira",
          "Hluw": "Hluw",
          "Hmng": "Hmng",
          "Hmnp": "Hmnp",
          "Hrkt": "Hrkt",
          "Hung": "Hung",
          "Ital": "Ital",
          "Jamo": "Jamo",
          "Java": "Java",
          "Jpan": "Jpan",
          "Kali": "Kali",
          "Kana": "Kana",
          "Khar": "Khar",
          "Khmr": "Khmr",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "Knda",
          "Kore": "Kore",
          "Kthi": "Kthi",
          "Lana": "Lana",
          "Laoo": "Laoo",
          "Latn": "Latn",
          "Lepc": "Lepc",
          "Limb": "Limb",
          "Lina": "Lina",
          "Linb": "Linb",
          "Lisu": "Lisu",
          "Lyci": "Lyci",
          "Lydi": "Lydi",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "Mand",
          "Mani": "Mani",
          "Marc": "Marc",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "Mero",
          "Mlym": "Mlym",
          "Modi": "Modi",
          "Mong": "Mong",
          "Mroo": "Mroo",
          "Mtei": "Mtei",
          "Mult": "Mult",
          "Mymr": "Mymr",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "Nkoo",
          "Nshu": "Nshu",
          "Ogam": "Ogam",
          "Olck": "Olck",
          "Orkh": "Orkh",
          "Orya": "Orya",
          "Osge": "Osge",
          "Osma": "Osma",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "Perm",
          "Phag": "Phag",
          "Phli": "Phli",
          "Phlp": "Phlp",
          "Phnx": "Phnx",
          "Plrd": "Plrd",
          "Prti": "Prti",
          "Qaag": "Qaag",
          "Rjng": "Rjng",
          "Rohg": "Rohg",
          "Runr": "Runr",
          "Samr": "Samr",
          "Sarb": "Sarb",
          "Saur": "Saur",
          "Sgnw": "Sgnw",
          "Shaw": "Shaw",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "Sinh",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "Sund",
          "Sylo": "Sylo",
          "Syrc": "Syrc",
          "Tagb": "Tagb",
          "Takr": "Takr",
          "Tale": "Tale",
          "Talu": "Talu",
          "Taml": "Taml",
          "Tang": "Tang",
          "Tavt": "Tavt",
          "Telu": "Telu",
          "Tfng": "Tfng",
          "Tglg": "Tglg",
          "Thaa": "Thaa",
          "Thai": "Thai",
          "Tibt": "Tibt",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "Ugar",
          "Vaii": "Vaii",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "Xpeo",
          "Xsux": "Xsux",
          "Yezi": "Yezi",
          "Yiii": "Yiii",
          "Zanb": "Zanb",
          "Zinh": "Zinh",
          "Zmth": "Zmth",
          "Zsye": "Zsye",
          "Zsym": "Zsym",
          "Zxxx": "Zxxx",
          "Zyyy": "Zyyy",
          "Zzzz": "Zzzz"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "sg"
})
}